module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_6.bb108ab5.png";